import Bowser from "bowser";
import {isPwa,isWebkit,isIosApp} from "@/utils/Pwa";

const browser = Bowser.getParser(window.navigator.userAgent);

const isIphone = browser.getOS().name === 'iOS';
const isAndroid = browser.getOS().name === 'Android';
const isChrome = browser.getBrowserName() === 'Chrome';
const isFirefox = browser.getBrowserName() === 'Firefox';
const isOpera = browser.getBrowserName().toLowerCase().includes('opera');
const isSafari = browser.getBrowserName() === 'Safari';
const isSamsungInternet = browser.getBrowserName() === 'Samsung Internet for Android';
const isBrowserAllowed = isChrome || isSafari || isFirefox || isOpera || isSamsungInternet;

const state = {
  isPwa,
  isWebkit: !!isWebkit,
  isIosApp: !!isIosApp,
  isIphone,
  isAndroid,
  isChrome,
  isFirefox,
  isOpera,
  isSafari,
  isSamsungInternet,
  isBrowserAllowed,
  canInstallPwa: !isPwa && !isIosApp && isBrowserAllowed && (isIphone || isAndroid)
};

export default {
  state
}
